import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { LoaderService } from 'src/app/services/loader.service';

@Component({
  selector: 'app-loading-overlay',
  templateUrl: './loading-overlay.component.html',
  styleUrls: ['./loading-overlay.component.scss'],
})
export class LoadingOverlayComponent implements OnInit {
  isVisible: boolean = false;

  constructor(private cdr: ChangeDetectorRef, private loaderService: LoaderService) {}

  ngOnInit(): void {
    this.loaderService.loading$.subscribe((state) => {
      this.isVisible = state;
      this.cdr.detectChanges();
    });
  }
}